/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrConfigGetResponse } from './irrConfigGetResponse';
import { SaasCspServiceDefinition } from './saasCspServiceDefinition';
import { ServiceState } from './serviceState';
import { ProductIdentifier } from './productIdentifier';


export interface IrrService { 
    serviceType?: ProductIdentifier;
    state?: ServiceState;
    config?: IrrConfigGetResponse;
    env?: SaasCspServiceDefinition;
}
export namespace IrrService {
}


